import {Button, FormControl} from 'platform/components';
import {HStack, Show, VStack} from 'platform/foundation';

import {useFieldArray} from 'react-hook-form';

import {i18n} from '@dms/i18n';

import {
  PurchasePriceRulePriceBandFormValues,
  PurchasePriceRuleFormValues,
} from '../PurchasePriceRuleFormSchema';
import {PurchasePriceRuleBandRow} from './PurchasePriceRuleBandRow';
import {PurchasePriceRuleBandsHeader} from './PurchasePriceRuleBandsHeader';
import {PurchasePriceRuleFormSection} from './PurchasePriceRuleFormSection';

const EMPTY_BAND: PurchasePriceRulePriceBandFormValues = {
  upperBound: null,
  marginType: 'FIXED_AMOUNT',
  marginValue: null,
};

interface PurchasePriceRuleBandsSectionProps {
  control: FormControl<PurchasePriceRuleFormValues>;
  isReadOnly: boolean;
  baseTestId: (suffix: string) => string;
}

export function PurchasePriceRuleBandsSection(props: PurchasePriceRuleBandsSectionProps) {
  const {fields, insert, remove} = useFieldArray({control: props.control, name: 'priceBands'});

  const lastIndex = fields.length - 1;

  return (
    <PurchasePriceRuleFormSection
      title={i18n.t('page.settings.purchasePrice.ruleEditor.bands.title')}
      description={i18n.t('page.settings.purchasePrice.ruleEditor.bands.description')}
      data-testid={props.baseTestId('bandsSection')}
    >
      <VStack spacing={3}>
        <PurchasePriceRuleBandsHeader />
        {fields.map((field, index) => (
          <PurchasePriceRuleBandRow
            key={field.id}
            control={props.control}
            index={index}
            isLast={index === lastIndex}
            isOnly={lastIndex === 0}
            isReadOnly={props.isReadOnly}
            onRemove={() => remove(index)}
            baseTestId={props.baseTestId}
          />
        ))}
      </VStack>

      <Show when={!props.isReadOnly}>
        <HStack>
          <Button
            variant="secondary"
            leftIcon="content/add"
            title={i18n.t('page.settings.purchasePrice.ruleEditor.bands.add')}
            onClick={() => insert(lastIndex, EMPTY_BAND)}
            data-testid={props.baseTestId('addBand')}
          />
        </HStack>
      </Show>
    </PurchasePriceRuleFormSection>
  );
}
